module.exports = __webpack_public_path__ + "static/media/ucf-logo.8a0e70b8.png";